function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import smoothScroll from "./smoothScroll";
function jobs() {
  init();
}
function init() {
  var searchBtn = '.search-job';
  var domenSite = "".concat(location.protocol, "//").concat(document.domain);
  refreshJobNavigationButtons();
  // refreshJobFunctionColors();

  loadMoreJobs();
  $('.no-result').hide();
  $('body').on('click', searchBtn, function () {
    // const $selectRegion = $('.region');
    var $selectCountry = $('.country');
    var $selectBusinessLines = $('.business-lines');
    var $selectEmploymentType = $('.employment-types');
    var linkApi = "/wp-json/artes/v2/all-jobs?country=".concat($selectCountry.val(), "&business-line=").concat($selectBusinessLines.val(), "&post_tag=");

    // Check if $selectEmploymentType has a non-empty value
    if ($selectEmploymentType.val() !== "") {
      // Append the employment-type parameter to the linkApi URL
      linkApi += "&employment_type=".concat($selectEmploymentType.val());
    }
    if (location.pathname.startsWith('/staging')) {
      linkApi = '/staging' + linkApi;
    }
    $('.load-more-jobs').attr('attr-link', linkApi);
    $('.job-offer-list, .job-offer-list__title').remove();
    jQuery('.job-offer-navigation .job-offer-navigation__button').remove();
    $('.no-result').hide();
    jQuery('<div>', {
      'class': 'spinner spinner-job-offer'
    }).insertAfter('.job-offer-panel');
    jQuery.getJSON(domenSite + linkApi, function (json) {
      var obj = json != '' ? $.parseJSON(json) : {};
      if (Object.keys(obj).length == 0) {
        $('.no-result').show();
      } else {
        $('.no-result').hide();
      }
      jQuery('.spinner.spinner-job-offer').remove();

      // if (Object.keys(obj).length > 9) {
      //   $('.load-more-jobs').show();
      // } else {
      //   $('.load-more-jobs').hide();
      // }

      $('.number').text(Object.keys(obj).length);

      // TODO: Adjust this
      if (Object.keys(obj).length < 4) {
        var jobsList = $("<div>", {
          "class": "job-offer-list"
        });
        var jobsListInner = $("<div>", {
          "class": "job-offer-list__inner"
        });
        jobsList.insertAfter('.job-offer-navigation');
        $('.job-offer-list').append(jobsListInner);
        for (var i in obj) {
          templateItem(obj[i], jobsListInner);
        }
      } else {
        // Old version with regions
        // var jobsGroupedRegion = {}

        // if ($selectRegion.val() != "") {
        //   jobsGroupedRegion[jQuery('select.region .select-input.selected .select-input__text').text()] = obj;
        // } else {
        //   for (const i in obj) {
        //     for (const region of obj[i].region) {
        //       if (!Object.keys(jobsGroupedRegion).includes(region)) {
        //         jobsGroupedRegion[region] = []
        //       }
        //       jobsGroupedRegion[region].push(obj[i])
        //     }
        //   }
        // }

        // Object.keys(jobsGroupedRegion).sort().forEach(jobRegion => {
        //   var jobListTitle = $("<div>",  {"class": "job-offer-list__title", id: `job-offer-group-${jobRegion.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-')}`});
        //   jobListTitle.html(jobRegion);
        //   jQuery('.section-job-offer > .container').append(jobListTitle)
        //   var jobsList = $("<div>", {"class": "job-offer-list"});
        //   var jobsListInner = $("<div>", {"class": "job-offer-list__inner"});
        //   jobsList.append(jobsListInner);
        //   jQuery('.section-job-offer > .container').append(jobsList)

        //   for (const i in jobsGroupedRegion[jobRegion]) {
        //     const job = jobsGroupedRegion[jobRegion][i]
        //     templateItem(obj[i], jobsListInner);
        //   }
        // });

        var jobsGroupedCountry = {};
        var jobsGroupedBusinessLine = {};
        if ($selectCountry.val() != "") {
          jobsGroupedCountry[jQuery('select.country .select-input.selected .select-input__text').text()] = obj;
        } else {
          for (var _i in obj) {
            var _iterator = _createForOfIteratorHelper(obj[_i].country),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var country = _step.value;
                if (!Object.keys(jobsGroupedCountry).includes(country)) {
                  jobsGroupedCountry[country] = [];
                }
                jobsGroupedCountry[country].push(obj[_i]);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
        if ($selectBusinessLines.val() != "") {
          jobsGroupedBusinessLine[jQuery('select.business-lines .select-input.selected .select-input__text').text()] = obj;
        } else {
          for (var _i2 in obj) {
            var businessLine = obj[_i2].business_line.replaceAll('&amp;', '&');
            if (!Object.keys(jobsGroupedBusinessLine).includes(businessLine)) {
              jobsGroupedBusinessLine[businessLine] = [];
            }
            jobsGroupedBusinessLine[businessLine].push(obj[_i2]);
          }
        }

        // console.log(jobsGroupedCountry)
        // console.log(jobsGroupedBusinessLine)

        var groupBy = jobsGroupedCountry;
        if ($selectCountry.val() != "" && $selectBusinessLines.val() == "") {
          groupBy = jobsGroupedBusinessLine;
        }
        Object.keys(groupBy).sort().forEach(function (groupIdentifier) {
          var jobListTitle = $("<div>", {
            "class": "job-offer-list__title",
            id: "job-offer-group-".concat(groupIdentifier.toLowerCase().replaceAll(' & ', '').replaceAll(' ', '-').replaceAll('/', '-'))
          });
          jobListTitle.html(groupIdentifier);
          jQuery('.section-job-offer > .container').append(jobListTitle);
          var jobsList = $("<div>", {
            "class": "job-offer-list"
          });
          var jobsListInner = $("<div>", {
            "class": "job-offer-list__inner"
          });
          jobsList.append(jobsListInner);
          jQuery('.section-job-offer > .container').append(jobsList);
          for (var _i3 in groupBy[groupIdentifier]) {
            var job = groupBy[groupIdentifier][_i3];
            templateItem(job, jobsListInner);
          }
        });
      }
      refreshJobNavigationButtons();
      // refreshJobFunctionColors();
    });
    $('.load-more-jobs').remove();
  });
}
function templateItem(obj_item, jobsList) {
  // const html_item = '<div class="col">\n'
  //       + '                    <div class="job-offer-post">\n'
  //       + '                        <div class="job-offer-post__vacancy">\n'
  //       + '                                <span class="job-offer-post__vacancy-text">\n'
  //       + `                                    ${obj_item.title}\n`
  //       + '                                </span>\n'
  //       + '                        </div>\n'
  //       + '                        <div class="job-offer-post__body">\n'
  //       + '                            <div class="job-offer-post__top-info">\n'
  //       + '                                    <span class="job-offer-post__data">\n'
  //       + `                                        ${obj_item.dateJob}\n`
  //       + '                                    </span>\n'
  //       + '                                <span class="job-offer-post__code">\n'
  //       + '                                        \n'
  //       + '                                    </span>\n'
  //       + '                            </div>\n'
  //       + '                           <div class="job-offer-post__main-info">\n'
  //       + '                                   <span class="job-offer-post__type-job">\n'
  //       + `                                   <span class="dashicons dashicons-location"></span>${obj_item.worklocation}\n`
  //       + '                                    </span>\n'
  //       + '                                <span class="job-offer-post__cities">\n'
  //       + `                                    <span class="dashicons dashicons-welcome-learn-more"></span>${obj_item.functiongroups}<br>\n`
  //       + `                                    <span class="job-offer-post__function">`
  //       + `                                    <span class="dashicons dashicons-businessperson"></span>`
  //       + `                                    <span class="job-offer-post__function-text">${obj_item.business-lines}</span></span>\n`
  //       + '                                    </span>\n'
  //       + '                            </div>\n'
  //       + '                            <div class="job-offer-post__text">\n'
  //       + `                                <p>${obj_item.content}</p>\n`
  //       + '                            </div>\n'
  //       + '                            <div class="job-offer-post__btn-wrap">\n'
  //       + `                                <a href="${obj_item.link}" class="btn">\n`
  //       + '                                    ZUM STELLENANGEBOT\n'
  //       + '                                </a>\n'
  //       + '                            </div>\n'
  //       + '                        </div>\n'
  //       + '                    </div>\n'
  //       + '                </div>';

  var html_item = "<div class=\"col\">\n                      <div class=\"job-offer-post\">\n                          <div class=\"job-offer-post__vacancy\">\n                              <span class=\"job-offer-post__vacancy-text\">\n                              ".concat(obj_item.title, "\n                              </span>\n                          </div>\n                          <div class=\"job-offer-post__body\">\n                              <div class=\"job-offer-post__top-info\">\n                                  <span class=\"job-offer-post__data\">\n                                    ").concat(obj_item.dateJob, "\n                                  </span>\n                                  <span class=\"job-offer-post__code\">\n\n                                  </span>\n                              </div>\n                              <div class=\"job-offer-post__main-info\">\n                                  <span class=\"job-offer-post__location\">\n                                      <span class=\"dashicons dashicons-location\"></span>\n                                      ").concat(obj_item.worklocation, "\n                                  </span>\n                                  <!--<span class=\"job-offer-post__type-job\">\n                                      <span class=\"dashicons dashicons-welcome-learn-more\"></span>\n                                      ").concat(obj_item.functiongroups, "<br>\n                                  </span>\n                                  <span class=\"job-offer-post__function\">\n                                      <span class=\"dashicons dashicons-businessperson\"></span>\n                                      <span class=\"job-offer-post__function-text\">").concat(obj_item.functions, "</span>\n                                  </span>-->\n                                  <span class=\"job-offer-post__reference\">\n                                      <span class=\"dashicons dashicons-tag\"></span>\n                                      Referenznr.: ").concat(obj_item.managed_by_carerix ? '#' : '').concat(obj_item.codeJob, "\n                                  </span>\n                              </div>\n                              <div class=\"job-offer-post__text\">\n                                  <p>").concat(obj_item.content, "\n                                  </p>\n                              </div>\n                              <div class=\"job-offer-post__btn-wrap\">\n                                  <a href=\"/").concat(obj_item.link, "\" class=\"btn\">\n                                      ZUM STELLENANGEBOT\n                                  </a>\n                              </div>\n                          </div>\n                      </div>\n                    </div>\n  ");
  $(jobsList).append(html_item);
}
function loadMoreJobs() {
  var jobsList = '.job-offer-list .job-offer-list__inner';
  var loadBtn = '.load-more-jobs';
  var linkApi = $(loadBtn).attr('attr-link');
  $('body').on('click', loadBtn, function () {
    jQuery.getJSON("".concat(location.protocol, "//").concat(document.domain).concat(linkApi), function (json) {
      var obj = json != '' ? $.parseJSON(json) : {};
      for (var i in obj) {
        templateItem(obj[i], jobsList);
      }
    });
    $(loadBtn).hide();
  });
}
function refreshJobNavigationButtons() {
  jQuery('.job-offer-navigation .job-offer-navigation__button').remove();
  if (jQuery('.job-offer-list__title').length > 1) {
    jQuery('.job-offer-list__title').each(function () {
      var text = jQuery(this).text();
      if (text == 'Array') return;
      var id = jQuery(this).attr('id');
      var el = jQuery('<a>', {
        'class': 'job-offer-navigation__button',
        href: "#".concat(id)
      });
      el.html(text);
      jQuery('.job-offer-navigation__inner').append(el);
    });
    smoothScroll();
  }
}
function refreshJobFunctionColors() {
  // var colors = ['#ee82ee', '#008b8b', '#00fa9a', '#ffa500', '#d2691e', '#7f0000', '#8b008b', '#00ffff', '#191970', '#556b2f', '#ff00ff', '#f08080', '#ff1493', '#00ff00', '#dc143c', '#3cb371', '#1e90ff', '#ff0000', '#4682b4', '#f7b731', '#8a2be2', '#0000ff', '#008000', '#696969', '#7b68ee', '#32cd32', '#d2b48c', '#d8bfd8', '#b03060', '#adff2f']
  var functionColors = {};
  var i = 0;
  var count = jQuery('select.business-lines > option').length - 2;
  jQuery('select.business-lines > option').each(function () {
    if (!jQuery(this).val() == "") {
      var hue = i * (360 / count) % 360;
      functionColors[jQuery(this).text().trim()] = "hsl(".concat(hue, ",75%,50%,0.95)");
      i++;
    }
  });
  jQuery('.job-offer-post__function').each(function () {
    var jobFunction = jQuery(this).children('.job-offer-post__function-text').text().trim();
    if (Object.keys(functionColors).includes(jobFunction)) {
      jQuery(this).children('.job-offer-post__function-dot').remove();
      var dot = jQuery('<span>', {
        'class': 'job-offer-post__function-dot'
      });
      dot.html('<span class="dashicons dashicons-tag"></span>');
      dot.css('color', functionColors[jobFunction]);
      jQuery(this).append(dot);
    } else {
      jQuery(this).remove();
    }
  });
}
export default jobs;